import { useCallback, useEffect, useState, useRef } from 'react';
import type { CascadingSelectState } from '@atlassian/jira-jql-builder-basic-cascading-select/src/common/types.tsx';
import type { hydrateJqlBuilderQuery$data } from '@atlassian/jira-relay/src/__generated__/hydrateJqlBuilderQuery.graphql';
import type { ui_jqlBuilder_JQLBuilderUI_hydrationQueryData$data } from '@atlassian/jira-relay/src/__generated__/ui_jqlBuilder_JQLBuilderUI_hydrationQueryData.graphql';

export const useSelectedValues = (
	hydratedData: hydrateJqlBuilderQuery$data | ui_jqlBuilder_JQLBuilderUI_hydrationQueryData$data,
	selectedOptionsFromHydration: CascadingSelectState | undefined,
) => {
	const prevHydrationData = useRef<
		hydrateJqlBuilderQuery$data | ui_jqlBuilder_JQLBuilderUI_hydrationQueryData$data
	>(hydratedData);
	const [hydrated, setHydrated] = useState(true);

	// Allow optimistic updates when a value is selected while hydration is taking place
	const [optimisticValues, setOptimisticValues] = useState<CascadingSelectState | undefined>();

	// Only flag values as hydrated after a data change
	useEffect(() => {
		if (!hydrated && hydratedData !== prevHydrationData.current) {
			setHydrated(true);
		}
		prevHydrationData.current = hydratedData;
	}, [hydrated, hydratedData]);

	const setSelectedValues = useCallback((values: CascadingSelectState) => {
		setHydrated(false);
		setOptimisticValues(values);
	}, []);

	const selectedValues =
		!hydrated && optimisticValues ? optimisticValues : selectedOptionsFromHydration;
	return [selectedValues, setSelectedValues] as const;
};
